import { useEffect, useState } from 'react'

import { CustomCard } from 'services/apiTypes/customCards.types'
import { CardType, defaultCard } from 'types/deck'

import CustomCardOverlay from 'components/customCards/CustomCardOverlay'
import PhatButton from 'components/formElements/PhatButton'
import ToastService from 'services/toast.service'

type Props = {
  label?: string
  onCopied?: (customCard: CustomCard) => void
} & ({ card: CardType; cards?: never } | { card?: never; cards: CardType[] }) &
  (
    | { parentControlled: true; open: boolean; onClose: () => void }
    | { parentControlled?: false; open?: never; onClose?: never }
  )

const CopyCustomCard = ({
  card,
  cards,
  label,
  parentControlled = false,
  onCopied,
  open: parentOpen,
  onClose,
}: Props) => {
  const [open, setOpen] = useState(parentOpen || false)

  useEffect(() => {
    if (!parentControlled) return

    setOpen(parentOpen || false)
  }, [parentOpen, parentControlled])

  const handleCopyCustomCard = async (customCard: CustomCard) => {
    ToastService.create('Custom card copied', 'Custom Card Service', 'success')

    if (onCopied) onCopied(customCard)

    handleClose()
  }

  const handleClose = () => {
    if (onClose) onClose()

    if (!parentControlled) setOpen(false)
  }

  // Remove any of the owner info & image URLs when copying
  const cardClearedOfCustomCardInfo: CardType = card
    ? {
        ...card,
        customCard: {
          id: null,
          ownerId: null,
          frontImageUrl: null,
          backImageUrl: null,
        },
      }
    : defaultCard

  return (
    <>
      {!parentControlled && (
        <PhatButton onClick={() => setOpen(true)} icon="copy outline">
          {label ? label : 'Copy custom card'}
        </PhatButton>
      )}

      <CustomCardOverlay
        saveableByDefault
        card={(open && cardClearedOfCustomCardInfo) || null}
        onClose={handleClose}
        onCardEdited={handleCopyCustomCard}
      />
    </>
  )
}

export default CopyCustomCard
